import React, { useState, useEffect } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from "common";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import { SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from "@mui/material/styles";
import theme from "styles/tableStyle";
import TableStyle from "../components/Table/Style";
import localization from "../components/Table/Localization";
import FranchiseSelector from "../components/FranchiseSelector";
import { DEFAULT_FRANCHISE_ID } from "../config/FranchisesConfig";

const Withdraws = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { completeWithdraw } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const columns = [
    { title: "ID", field: "id", editable: "never" },
    {
      title: t("requestDate"),
      field: "date",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.date ? moment(rowData.date).format("lll") : null,
      exportTransformer: (rowData) =>
        new Date(rowData.date).toLocaleDateString() +
        " " +
        new Date(rowData.date).toLocaleTimeString(),
    },
    { title: t("driver_name"), field: "name", editable: "never" },
    {
      title: t("amount"),
      field: "amount",
      editable: "never",
      render: (rowData) =>
        rowData.amount
          ? settings.swipe_symbol
            ? rowData.amount + " " + settings.symbol
            : settings.symbol + " " + rowData.amount
          : settings.swipe_symbol
          ? "0 " + settings.symbol
          : settings.symbol + " 0",
    },
    {
      title: t("processed"),
      field: "processed",
      type: "boolean",
      editable: "never",
    },
    {
      title: t("processDate"),
      field: "processDate",
      render: (rowData) =>
        rowData.processDate ? moment(rowData.processDate).format("lll") : null,
    },
  ];
  const [data, setData] = useState([]);
  const withdrawdata = useSelector((state) => state.withdrawdata);
  const [selectedFranchiseId, setSelectedFranchiseId] = useState("all");
  const userdata = useSelector((state) => state.usersdata);

  useEffect(() => {
    if (withdrawdata.withdraws) {
      setData(
        withdrawdata.withdraws.filter((withdraw) => {
          const driver = userdata?.users?.find(
            (user) => user.id === withdraw.driver
          );
          return (
            selectedFranchiseId === "all" ||
            (driver && driver.franchise_id === selectedFranchiseId) ||
            (!driver?.franchise_id &&
              selectedFranchiseId === DEFAULT_FRANCHISE_ID)
          );
        })
      );
    } else {
      setData([]);
    }
  }, [withdrawdata.withdraws, userdata.users, selectedFranchiseId]);

  const [selectedRow, setSelectedRow] = useState(null);
  return withdrawdata.loading ? (
    <CircularLoading />
  ) : (
    <ThemeProvider theme={theme}>
      {auth.profile.franchise_id === DEFAULT_FRANCHISE_ID && (
        <FranchiseSelector
          setSelectedFranchiseId={setSelectedFranchiseId}
          selectedFranchiseId={selectedFranchiseId}
          onChange={(e) => setSelectedFranchiseId(e.target.value)}
        />
      )}
      <MaterialTable
        title={t("Withdraw_title")}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
          padding: "20px",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.date =
                new Date(row.date).toLocaleDateString() +
                " " +
                new Date(row.date).toLocaleTimeString();
              row.processDate = row.processDate
                ? new Date(row.processDate).toLocaleDateString() +
                  " " +
                  new Date(row.processDate).toLocaleTimeString()
                : "";
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "download.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id
                ? colors.ROW_SELECTED
                : colors.WHITE,
          }),
          ...TableStyle(),
        }}
        localization={localization(t)}
        actions={[
          (rowData) => ({
            icon: "check",
            tooltip: t("process_withdraw"),
            disabled: rowData.processed,
            onClick: (event, rowData) => {
              dispatch(completeWithdraw(rowData));
            },
          }),
        ]}
      />
    </ThemeProvider>
  );
};

export default Withdraws;
